// extracted by mini-css-extract-plugin
module.exports = {"form":"change-password_form__wBLI8","captionSessions":"change-password_captionSessions__16LEY","actions":"change-password_actions__rlNEP"};